import { render, staticRenderFns } from "./RegistrationRange.vue?vue&type=template&id=5d9306d4&lang=pug&"
import script from "./RegistrationRange.vue?vue&type=script&lang=js&"
export * from "./RegistrationRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports